module.exports = __webpack_public_path__ + "static/img/tab_active_1.87240697.png";